import script from "./content.vue?vue&type=script&setup=true&lang=js"
export * from "./content.vue?vue&type=script&setup=true&lang=js"

import "./content.vue?vue&type=style&index=0&id=1242d5ed&scoped=true&lang=less"
import "./content.vue?vue&type=style&index=1&id=1242d5ed&lang=css"

import exportComponent from "/workspace/office-website/company-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1242d5ed"]])

export default __exports__